import React, { useState } from 'react';
import './tabs.scss';

export type TabItem = {
  title: string;
  subtitle?: string;
  content: React.ReactNode;
};
export type TabData = TabItem[];

interface TabsProps {
  tabData: TabData;
  activeIndex?: number;
  onTabChange?: (index: number) => void;
}

const Tabs = ({ tabData, activeIndex, onTabChange }: TabsProps) => {
  const [activeTab, setActiveTab] = useState(0);
  const currentIndex = activeIndex !== undefined ? activeIndex : activeTab;

  const handleTabClick = (index: number) => {
    if (onTabChange) {
      onTabChange(index);
    } else {
      setActiveTab(index);
    }
  };

  return (
    <div className='tabs-container'>
      <div className='tab-controls' role='tablist'>
        {tabData?.map((tab, index) => (
          <React.Fragment key={tab.title + tab.subtitle + index}>
            <button
              className={currentIndex === index ? 'active' : ''}
              key={index}
              onClick={() => handleTabClick(index)}
              role='tab'
              type='button'
            >
              <div className='tab-title'>{tab.title}</div>
              {tab.subtitle && <div className='tab-subtitle'>{tab.subtitle}</div>}
            </button>
          </React.Fragment>
        ))}
      </div>
      <div className='tab-content'>{tabData?.[currentIndex]?.content}</div>
    </div>
  );
};
export default Tabs;
